module.exports = __webpack_public_path__ + "static/media/agzalogo.7b3dd2c2.jpg";